"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NftModule = void 0;
const types_1 = require("../types");
/**
 * @deprecated Use GraphQLModule instead.
 */
class NftModule {
    constructor(axiosInstance) {
        this._axios = axiosInstance;
    }
    /**
     * Retrieves the collectibles owned by a specific wallet address.
     *
     * @param walletAddress - The wallet address of the owner.
     * @returns A Promise that resolves to an Account object representing the owner's account.
     * @throws If there is an error retrieving the collectibles or if the response status is not 200.
     */
    getCollectiblesByOwner(walletAddress) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const result = yield this._axios.get(`/v0/graphql/collectibles/${walletAddress}`);
                if (result.status === 200) {
                    if (!((_b = (_a = result.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.account)) {
                        return new types_1.Account({ id: walletAddress, address: walletAddress, collectibles: [] });
                    }
                    else {
                        return types_1.Account.fromJson(result.data.data.account);
                    }
                }
                throw result;
            }
            catch (error) {
                throw error;
            }
        });
    }
}
exports.NftModule = NftModule;
